import { enqueueSnackbar } from 'notistack';

import { COMMON_SERVICE_STRINGS } from '@/constants/constant';

const serviceHelper = async (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  request: Promise<any>,
  showAlert: boolean = false,
  showErrorAlert: boolean = true
) => {
  try {
    const response = await request;
    const successMessage =
      response?.data?.message || COMMON_SERVICE_STRINGS.SUCCESS_MSG;
    if (showAlert) {
      enqueueSnackbar(successMessage, { variant: 'success' });
    }
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message || COMMON_SERVICE_STRINGS.ERROR_MSG;
    if (showErrorAlert) {
      enqueueSnackbar(errorMessage, { variant: 'error' });
    }
    return error?.response?.data;
  }
};

export default serviceHelper;
